import { Icon } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import LoadingIcon from "../../components/LoadingIcon";
import { AccessesFromLog } from "../../services/ResourceRelationsService";
import { ErrorMessagesIconTooltip } from "../Relations/ErrorMessagesIconTooltip";
import { IAccessRelationData } from "./AccessDomainModels";
import { ALERT, getAccessAlertCode } from "./AlertHelper";
import { IConfig } from "./IModels";

interface IProps {
	config: IConfig;
	row: IAccessRelationData;
	allRows: IAccessRelationData[];
	accessesFromLog: AccessesFromLog;
}

export function RenderAlert(props: IProps) {
	const row = props.row;
	const { t } = useTranslation();

 	if (row.errorMessages && row.errorMessages.length > 0) {
		return <ErrorMessagesIconTooltip errorMessages={row.errorMessages} />;
	}

	if (!row.employee)
		return null;

	const alert = getAccessAlertCode({
		row,
		accessesFromLog: props.accessesFromLog,
		allRows: props.allRows,
		config: props.config
	});

	if (alert == ALERT.Loading)
		return <LoadingIcon />;
	if (alert == ALERT.Error)
		return null;
	if (alert == ALERT.Access) {
		if (row.role) {
			let roleName = row.role.name;
			return <Icon title={t("control.relation.accessExist", { label: row.resource.label, roleName })} className="text-warning" >info</Icon>;
		}
		return <Icon title={t("control.relation.accessExistWithoutRole", { label: row.resource.label})} className="text-warning" >info</Icon>;
	}

	if (alert == ALERT.NoAccess) {
		return <Icon title={t("control.relation.newAccess")} className="text-success" >check_circle</Icon>;
	}

	if (alert == ALERT.DuplicatedRows) {
		return <Icon title={t("control.relation.duplicatedRows")} className="text-danger" >info</Icon>;
	}
	if (alert == ALERT.DuplicatedAccess) {
		return <Icon title={t("control.relation.duplicatedAccess")} className="text-danger" >info</Icon>;
	}

	return null;
}